import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scroll en haut à chaque changement de route + envoi page_view à Google Analytics (si consentement).
 * Permet d'avoir les analytics par "page" dans la SPA.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    // Google Analytics (GA4) : page_view par route (chargé uniquement après consentement Tarteaucitron)
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'page_view', {
        page_path: pathname,
        page_title: document.title,
      });
    }
  }, [pathname]);

  return null;
}
